<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="answer-evaluation-counter">
      <div
        class="answer-counter-item"
        v-for="(item, index) in questionList"
        :key="item.id"
      >
        <!-- 简答题 -->
        <div style="margin-top: 15px;">
          <span style="color: red" v-if="item.isRequired">* </span>
          {{ index + 1 }}、{{ item.title
          }}<span v-if="item.type == 3"
            >({{ $t("minSelect", [item.minOption]) }}，{{
              $t("maxSelect", [item.maxOption])
            }})</span
          >
          <div class="short-evaluation-upload" v-if="item.type == 1">
            <van-field
              :disabled="$route.query.isPreview == 1"
              v-model="item.shortAnswer"
              rows="3"
              autosize
              type="textarea"
              :placeholder="$t('nullExplain')"
            />
            <van-uploader
              :disabled="$route.query.isPreview == 1"
              v-model="item.fileImagesList"
              :after-read="(file) => afterRead(file, item)"
              :before-delete="(file, detail) => handleDelete(detail, item)"
              v-if="item.isMustUpload"
              :max-count="9"
            />
          </div>
          <!-- 单选题 -->
          <div class="radio-type-answer" v-if="item.type == 2">
            <van-radio-group v-model="item.radioAnswer">
              <van-radio
                :disabled="$route.query.isPreview == 1"
                v-for="child in item.optionList"
                :key="child.id"
                :name="child.id"
                >{{ child.content }}</van-radio
              >
            </van-radio-group>
          </div>
          <!-- 多选题 -->
          <div class="checkbox-type-answer" v-if="item.type == 3">
            <van-checkbox-group v-model="item.checkAnswer">
              <van-checkbox
                :disabled="$route.query.isPreview == 1"
                shape="square"
                v-for="child in item.optionList"
                :key="child.id"
                :name="child.id"
                >{{ child.content }}</van-checkbox
              >
            </van-checkbox-group>
          </div>
          <!-- 排序题 -->
          <div class="checkbox-type-answer" v-if="item.type == 4">
            <van-checkbox-group v-model="item.rankAnswer">
              <van-checkbox
                :disabled="$route.query.isPreview == 1"
                shape="square"
                v-for="child in item.optionList"
                :key="child.id"
                :name="child.id"
                >{{ child.content }}</van-checkbox
              >
            </van-checkbox-group>
          </div>
          <!-- 评分题 -->
          <div class="rank-type-answer" v-if="item.type == 5">
            <van-rate
              :readonly="$route.query.isPreview == 1"
              v-model="item.rankStarAnswer"
              :size="18"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
              @change="handleChangeRate(item, $event)"
              :count="item.minOption"
            />
            <div style="font-size: 14px">{{ item.rankExplain || "" }}</div>
          </div>
        </div>
      </div>
      <div class="submit-btn" @click="handleSubmitAnswer">
        {{ $route.query.isPreview == 1 ? $t("returnBtn") : $t("submitBtn") }}
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      shortAnswer: "",
      fileImagesList: [],
      radioAnswer: "",
      checkAnswer: [],
      rankStar: 0,
      surveyDetail: {},
      questionList: [],
      customerId: "",
      shopId: "",
      startTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  async mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    this.shopId = localStorage.getItem("shopId");
    await this.getSurveyDetail(this.$route.query.id);
    if (this.$route.query.isPreview) {
      await this.getCustomerSurveyAnswer(this.$route.query.id);
    }
  },
  methods: {
    afterRead(file, item) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let formData = new FormData();
        formData.append("shopId", localStorage.getItem("shopId"));
        formData.append("file", file.file);
        formData.append("type", 2);
        this.$authAjax.post("/api/wxapp/file/upload", formData).then((res) => {
          let { data } = res;
          if (data.code == 200) {
            item.images.push(data.data);
          } else {
            this.$toast(data.message);
          }
        });
      } finally {
        this.$toast.clear();
      }
    },
    handleDelete(detail, item) {
      item.images.splice(detail.index, 1);
      item.fileImagesList.splice(detail.index, 1);
    },
    // 获取问卷详情
    async getSurveyDetail(id) {
      if (!id) return;
      const { data: res } = await this.$authAjax.get(
        "/api/wxapp/survey/getSurveyDetailById?id=" + id
      );
      this.surveyDetail = res?.data;
      this.questionList = res?.data?.questionList;
      this.questionList?.map((item) => {
        if (item.type == 1) {
          item.images = [];
        }
      });
    },
    // 提交
    async handleSubmitAnswer() {
      if (this.$route.query.isPreview == 1) {
        return this.$router.back();
      }
      let answerOptionList = [];
      this.questionList?.forEach((item) => {
        switch (item.type) {
          // 简答题
          case 1:
            if (item.isMustUpload && !item.images) {
              this.$toast("请上传简答题图片");
              return;
            }
            if (item.isRequired || item.shortAnswer || item.images) {
              answerOptionList.push({
                questionId: item.id,
                content: item.shortAnswer,
                images: item.images?.join(","),
                // optionId: item.optionList?.[0]?.id
              });
            }
            break;
          // 单选题
          case 2:
            if (item.isRequired || item.radioAnswer) {
              answerOptionList.push({
                questionId: item.id,
                optionId: item.radioAnswer,
              });
            }
            break;
          // 多选题
          case 3:
            if (item.isRequired || item?.checkAnswer?.length > 0) {
              item?.checkAnswer?.map((check) => {
                answerOptionList.push({
                  questionId: item.id,
                  optionId: check,
                });
              });
            }
            break;
          // 排序题
          case 4:
            if (item.isRequired || item?.rankAnswer?.length > 0) {
              item?.rankAnswer?.map((rank, index) => {
                answerOptionList.push({
                  questionId: item.id,
                  optionId: rank,
                  order: index + 1,
                });
              });
            }
            break;
          // 评分题
          case 5:
            if (item.isRequired || item.rankStarAnswer > 0) {
              answerOptionList.push({
                questionId: item.id,
                optionId: item?.optionList?.[item.rankStarAnswer - 1]?.id,
              });
            }
            break;
        }
      });
      await this.$authAjax.post("/api/wxapp/survey/submitSurveyAnswer", {
        shopId: this.shopId,
        customerId: this.customerId,
        surveyId: this.$route.query.id,
        source: 3,
        startTime: this.startTime,
        answerOptionList,
        version: this.surveyDetail.version,
        serialNumber: this.surveyDetail.serialNumber
      });
      this.$router.replace({
        path: "/evaluation/explain",
        query: {
          type: "success",
        },
      });
    },
    // 获取答案
    async getCustomerSurveyAnswer(id) {
      if (!id) return;
      const { data: res } = await this.$authAjax.get(
        "/api/wxapp/survey/getCustomerAnswer",
        {
          params: {
            surveyId: id,
            customerId: this.customerId,
          },
        }
      );
      res?.data?.answerQuestionList?.map((item) => {
        res?.data?.answerOptionList?.map((answer) => {
          if (item.questionId == answer.questionId) {
            if (item.questionType == 1) {
              item.images = answer.images;
            }
          }
        });
      });
      const answerQuestionList = res?.data?.answerQuestionList;
      this.questionList?.map((item) => {
        const matchedAnswer = answerQuestionList.find(
          (ans) => ans.questionId == item.id && ans.questionType == item.type
        );
        switch (item.type) {
          // 简答题
          case 1:
            item.shortAnswer = matchedAnswer?.answer;
            if(matchedAnswer?.images) {
              item.images = matchedAnswer?.images?.split(",");
              item.fileImagesList = [];
              item.images?.map((img) => {
                item.fileImagesList.push({
                  url: img,
                });
              });
            }
            break;
          // 单选题
          case 2:
            item.radioAnswer = Number(matchedAnswer?.answerOptionIds);
            break;
          // 多选题
          case 3:
            item.checkAnswer = matchedAnswer?.answerOptionIds
              ?.split(",")
              ?.map(Number);
            break;
          // 排序题
          case 4:
            item.optionList = matchedAnswer?.answer
              ?.split(",")
              ?.map((content, index) => ({
                content,
                id: matchedAnswer?.answerOptionIds.split(",")[index],
              }));
            break;
          // 评分
          case 5: {
            let index = item.optionList?.findIndex(
              (rank) => rank.id == matchedAnswer?.answerOptionIds
            );
            item.rankStarAnswer = index + 1;
            item.rankExplain = matchedAnswer?.answer;
            break;
          }
        }
      });
      this.$forceUpdate();
    },
    handleChangeRate(item, e) {
      item.rankExplain = item.optionList[e - 1]?.content;
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-evaluation-counter {
  padding: 12px;
  box-sizing: border-box;
  overflow: auto;
  height: 100vh;
  // margin-top: 45px;
  .answer-counter-item {
    font-size: 15px;
    .short-evaluation-upload {
      padding: 12px;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 4px;
      margin-top: 10px;
      ::v-deep .van-cell {
        padding: 0;
        &::after {
          border-bottom: none;
        }
      }
    }
    .radio-type-answer {
      // margin-top: 10px;
      padding-left: 12px;
      ::v-deep .van-radio {
        margin-top: 10px;
      }
    }
    .checkbox-type-answer {
      padding-left: 12px;
      ::v-deep .van-checkbox {
        margin-top: 10px;
      }
    }
    .rank-type-answer {
      padding-left: 12px;
      margin-top: 10px;
    }
  }
  .submit-btn {
    width: 343px;
    padding: 12px 0;
    background: #0ea7f3;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 50px;
  }
}
</style>
